import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { AuthGuardAuthenticatedOnly } from '@core/services/auth-guard-authenticated-only.service';
import { RolesComponent } from './pages/tickets/components/employees/roles/roles.component';
import { PermissionGuard } from '@core/guards/permission-guard.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardAuthenticatedOnly],
    children: [
      {
        path: '',
        data: { title: 'Summary' },
        loadChildren: () =>
          import('./pages/welcome/welcome.module').then((m) => m.WelcomeModule),
      },
      {
        path: 'tickets',
        data: { title: 'Tickets' },
        loadChildren: () =>
          import('./pages/tickets/tickets.module').then((m) => m.TicketsModule),
      },
      {
        path: 'tickets-setup',
        data: { title: 'Setup' },
        loadChildren: () =>
          import('./pages/tickets-setup/tickets-setup.module').then(
            (m) => m.TicketsSetupModule
          ),
      },
      {
        path: 'employees',
        // canActivate: [PermissionGuard],
        data: { permission: 'employee', title: 'Employees' },
        loadChildren: () =>
          import('./pages/tickets/components/employees/employee.module').then(
            (m) => m.EmployeeModule
          ),
      },
      {
        path: 'time-tracking',
        // canActivate: [PermissionGuard],
        data: { permission: 'timetracking', title: 'Time Tracking' },
        loadChildren: () =>
          import('./pages/time-tracking/time-tracking.module').then(
            (m) => m.TimeTrackingModule
          ),
      },
      {
        path: 'hr',
        data:{permission:'hr', title: 'HR'},
        loadChildren: () =>
          import('./pages/hr/hr.module').then(
            (m) => m.HrModule
          ),
      },
      {
        path: 'business-profile',
        data: { title: 'Business Profile' },
        loadChildren: () =>
          import('./pages/business-profile/business-profile.module').then(
            (m) => m.BusinessProfileModule
          ),
      },
      {
        path:'note-setup',
        data:{permission:'hr', title: 'HR'},
        loadChildren: () =>
          import('./pages/notes-setup/notes-setup.module').then(
            (m) => m.NotesSetupModule
          ),
      },
      {
        path: 'transportation',
        data:{permission:'transportation', title: 'Transportation'},
        loadChildren: () =>
          import('./pages/transportation/transportation.module').then(
            (m) => m.TransportationModule
          ),
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
